<template>
	<div class="basic_wrap">
		<van-nav-bar
			safe-area-inset-top
			fixed
			:title="$t('lh.还款')"
			left-arrow
			@click-left="$router.back()"
		/>
		
		<div class="box">
			<div class="balance card">
<!--				<p>{{ $t('lh.最高可借') }}</p>-->
<!--				<p class="bold">{{ totalMoney }}</p>-->
				<p class="sub">{{ $t('lh.当前借款') }}: {{ usedMoney }}</p>
			</div>
			
			<div class="balance">
				<input v-model.trim="password" type="number" step="0.01" class="inp" :placeholder="$t('lh.请输入支付密码')">
				
				<van-button
					class="btn"
					block
					color="linear-gradient(0deg, rgb(173, 134, 103) 0%, rgb(244, 228, 215) 100%)"
					@click="submit"
				>
					{{ $t('lh.还款') }}
				</van-button>
			</div>
			
		</div>
	</div>
</template>


<script>
import Fetch from '@/utils/fetch';

export default {
	name: "reserve",
	data() {
		return {
			usedMoney: 0,
			id: '',
			password: '',
		}
	},
	created() {
		this.$parent.footer('', false);
		this.id = this.$route.query.id;
		this.usedMoney = this.$route.query.money;
	},
	methods: {
		submit(){
			Fetch('/user/repayLoad', { id: this.id , password: this.password }).then(()=>{
				this.$toast(this.$t('lh.还款成功'));
				this.$router.back()
			})
		},
	}
}
</script>


<style scoped lang="less">
.list {
	width: 96%;
	margin-left: 2%;
	border-radius: 6px;
	margin-top: 10px;
	
	.item {
		margin-top: 10px;
		display: flex;
		//align-items: center;
		justify-content: space-between;
		padding: 16px 8px;
		border: 1px solid #917E70;
		border-radius: 0.59375rem;
		background: #4B4241;
		color: #f5e7db;
		
		.de_wrap {
			text-align: left;
			flex: 2;
			
			.tit {
				font-size: 14px;
				line-height: 20px;
				font-weight: bold;
			}
			
			.time {
				font-size: 12px;
				line-height: 17px;
				margin-top: 10px;
			}
		}
		
		.price {
			flex: 1;
			font-size: 18px;
			line-height: 28px;
			font-weight: bold;
			text-align: right;
			color: #f5e7db;
			white-space: nowrap;
			
			&.del {
				color: #3FAF3E;
			}
			
			.status {
				font-size: .8rem !important;
			}
			
			.r{
				font-size: .7rem !important;
			}
		}
	}
}
.tab {
	display: flex;
	align-items: center;
	justify-content: space-evenly;
	
	.tab-item {
		background-color: #4d4141;
		width: 9rem;
		height: 2.15625rem;
		border-radius: 0.21875rem;
		color: #e6dada;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: .75rem;
	}
	
	.active {
		color: #311500;
		background: linear-gradient(0deg, #B08868 1%, #B08868 21%, #F5E6DD 100%);
	}
}

.list {
	margin: 10px 0;
}

.inp {
	width: 100%;
	line-height: 30px;
	margin-bottom: 20px;
	border: 1px solid #917E70;
	padding: 10px;
	border-radius: 6px;
}

.card-1 {
	padding: 20px !important;
	box-sizing: border-box;
}

.card {
	width: 100%;
	background: #251E1F;
	border: 1px solid #917E70;
	border-radius: 0.59375rem;
	margin: 0 auto;
	margin-top: 1.25rem;
}

.balance {
	width: 96%;
	margin-left: 2%;
	//background: rgba(255, 255, 255, 1);
	border-radius: 6px;
	padding: 20px 0px;
	text-align: center;
	color: #999;
	
	.bold {
		font-size: 40px;
		font-weight: bold;
		margin: 10px 0;
	}
	
	.sub {
		font-size: 14px;
	}
	
	//p:nth-child(1) {
	//	color: #999;
	//	font-size: 26px;
	//	font-weight: bold;
	//	margin-bottom: 15px;
	//}
	//
	//p:nth-child(2) {
	//	color: #999;
	//	font-size: 20px;
	//	font-weight: bold;
	//}
}

.box-1 {
	margin-top: 1rem;
	margin-bottom: 1rem;
	border-radius: 0.25rem;
	padding: 1rem;
	color: #FFFFFF;
	border: 1px solid #3b3b3b;
	
}

/deep/ .van-nav-bar {
	color: rgb(239, 216, 196);
	background-color: rgb(35, 29, 29);
}

/deep/ .van-nav-bar__title {
	color: rgb(239, 216, 196);
}

/deep/ .van-nav-bar .van-icon {
	color: rgb(239, 216, 196);
}

.basic_wrap {
	padding-top: 46px;
	display: flex;
	height: 100vh;
	box-sizing: border-box;
	flex-direction: column;
	
	.box {
		//overflow: hidden;
		flex: 1;
		background: url(../../assets/img/home-bg.jpg) no-repeat;
		background-size: 100% 100%;
		box-sizing: border-box;
		padding: .3rem
	}
}
</style>
